<template>
  <page>
    <template slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              More Links...
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="sideMenuClick"></side-function-menu>
        </v-menu>
      </div>
    </template>
    <lazy-div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-btn text icon color="green">
            <v-icon @click="$router.go(-1)">mdi-keyboard-backspace</v-icon>
          </v-btn>
          <v-icon v-if="newMode">mdi-plus</v-icon>
          <v-icon v-else-if="reviewMode">mdi-pencil</v-icon>
          <v-icon v-else-if="queryMode">mdi-magnify</v-icon>
          <v-toolbar-title v-if="newMode">Create Treaty Parameters</v-toolbar-title>
          <v-toolbar-title v-else-if="reviewMode">Edit Treaty Parameters</v-toolbar-title>
          <v-toolbar-title v-else-if="queryMode">View Treaty Parameters</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6 v-if="newMode">
                <v-text-field
                  v-model="treatyForm.ttyNo"
                  :label="labels.ttyNo"
                  :error-messages="errors.collect('ttyNo')"
                  data-vv-name="ttyNo"
                  :data-vv-as="labels.ttyNo"
                  v-validate="'required|param|max:8'"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 v-else>
                <v-subheader class="queryLabel">{{ labels.ttyNo }}</v-subheader>
                <div class="queryValue">{{ treatyForm.ttyNo }}</div>
              </v-flex>
              <v-flex lg6 md6 xs12 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.ttyDesc }}</v-subheader>
                <div class="queryValue">{{ treatyForm.ttyDesc }}</div>
              </v-flex>
              <v-flex lg6 md6 xs12 v-else>
                <v-text-field
                  v-model="treatyForm.ttyDesc"
                  :label="labels.ttyDesc"
                  :error-messages="errors.collect('ttyDesc')"
                  data-vv-name="ttyDesc"
                  :data-vv-as="labels.ttyDesc"
                  v-validate="'required|max:40'"
                ></v-text-field>
              </v-flex>
              <v-flex lg6 md6 xs12 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.ttyType }}</v-subheader>
                <div class="queryValue" v-for="item in filterTtyTypeToList" :key="item.code">{{ item.value }}</div>
              </v-flex>
              <v-flex lg6 md6 xs12 v-else>
                <v-autocomplete
                  :label="labels.ttyType"
                  :items="ttyTypeList"
                  v-model="treatyForm.ttyType"
                  item-text="value"
                  item-value="code"
                  data-vv-name="ttyType"
                  :data-vv-as="labels.ttyType"
                  :error-messages="errors.collect('ttyType')"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>

              <!--
              Date
              Here
              Implement Later
            -->
              <v-flex lg6 md6 xs12 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.effDate }}</v-subheader>
                <div class="queryValue">{{ treatyForm.effDate }}</div>
              </v-flex>
              <v-flex lg6 md6 xs12 v-else>
                <cal-picker
                  :label="labels.effDate"
                  v-model="treatyForm.effDate"
                  :error-messages="errors.collect('effDate')"
                  data-vv-name="effDate"
                  :data-vv-as="labels.effDate"
                  v-validate="effDateValidation"
                  @input="doTranDate"
                ></cal-picker>
              </v-flex>
              <v-flex lg6 md6 xs12 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.expDate }}</v-subheader>
                <div class="queryValue">{{ treatyForm.expDate }}</div>
              </v-flex>
              <v-flex lg6 md6 xs12 v-else>
                <cal-picker
                  :label="labels.expDate"
                  v-model="treatyForm.expDate"
                  :error-messages="errors.collect('expDate')"
                  data-vv-name="expDate"
                  :data-vv-as="labels.expDate"
                  v-validate="expDateValidation"
                  @input="doTranDate"
                ></cal-picker>
              </v-flex>
              <!-- Treaty Year -->
              <v-flex lg6 md6 xs12 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.ttyYr }}</v-subheader>
                <div class="queryValue">{{ treatyForm.ttyYr }}</div>
              </v-flex>
              <v-flex lg6 md6 xs12 v-else>
                <v-text-field
                  v-model="treatyForm.ttyYr"
                  :label="labels.ttyYr"
                  :error-messages="errors.collect('ttyYr')"
                  data-vv-name="ttyYr"
                  :data-vv-as="labels.ttyYr"
                  v-validate="'mask_decimal:0|mask_min_value:1|required'"
                  :loading="ttyYrLoading"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <!-- Commission 1 -->
            <v-layout row wrap>
              <v-flex lg6 md6 xs12>
                <v-layout row wrap>
                  <v-flex v-if="queryMode">
                    <v-checkbox readonly v-model="treatyForm.comm1AE" :label="labels.comm1AE"></v-checkbox>
                  </v-flex>
                  <v-flex v-else>
                    <v-checkbox
                      v-model="treatyForm.comm1AE"
                      :label="labels.comm1AE"
                      :error-messages="errors.collect('comm1AE')"
                      data-vv-name="comm1AE"
                      :data-vv-as="labels.comm1AE"
                      v-validate="'required'"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.comm1Pct }}</v-subheader>
                    <div class="queryValue">{{ treatyForm.comm1Pct }}</div>
                  </v-flex>
                  <v-flex v-else>
                    <v-text-field
                      v-model="treatyForm.comm1Pct"
                      :label="labels.comm1Pct"
                      :error-messages="errors.collect('comm1Pct')"
                      data-vv-name="comm1Pct"
                      :data-vv-as="labels.comm1Pct"
                      v-validate="'required|mask_decimal:6|mask_min_value:0.000000'"
                      v-num-mask="{ negative: true, intScale: 18, decScale: 6 }"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex lg6 md6 xs12 v-if="queryMode">
                <v-checkbox readonly v-model="treatyForm.defComm1" :label="labels.defComm1"></v-checkbox>
              </v-flex>
              <v-flex v-else>
                <v-checkbox v-model="treatyForm.defComm1" :label="labels.defComm1" :error-messages="errors.collect('defComm1')" data-vv-name="defComm1" :data-vv-as="labels.defComm1" v-validate="'required'"></v-checkbox>
                  </v-flex>
            </v-layout>

            <!-- Commission 2 -->
            <v-layout row wrap>
              <v-flex lg6 md6 xs12>
                <v-layout row wrap>
                  <v-flex v-if="queryMode">
                    <v-checkbox readonly v-model="treatyForm.comm2AE" :label="labels.comm2AE"></v-checkbox>
                  </v-flex>
                  <v-flex v-else>
                    <v-checkbox
                      v-model="treatyForm.comm2AE"
                      :label="labels.comm2AE"
                      :error-messages="errors.collect('comm2AE')"
                      data-vv-name="comm2AE"
                      :data-vv-as="labels.comm2AE"
                      v-validate="'required'"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.comm2Pct }}</v-subheader>
                    <div class="queryValue">{{ treatyForm.comm2Pct }}</div>
                  </v-flex>
                  <v-flex v-else>
                    <v-text-field
                      v-model="treatyForm.comm2Pct"
                      :label="labels.comm2Pct"
                      :error-messages="errors.collect('comm2Pct')"
                      data-vv-name="comm2Pct"
                      :data-vv-as="labels.comm2Pct"
                      v-validate="'required|mask_decimal:6|mask_min_value:0.000000'"
                      v-num-mask="{ negative: true, intScale: 18, decScale: 6 }"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex lg6 md6 xs12 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.comm2GN }}</v-subheader>
                <div class="queryValue" v-for="item in filterComm2GNList" :key="item.code">{{ item.value }}</div>
              </v-flex>
              <v-flex lg6 md6 xs12 v-else>
                <v-autocomplete
                  :label="labels.comm2GN"
                  :items="comm2GNList"
                  v-model="treatyForm.comm2GN"
                  item-text="value"
                  item-value="code"
                  data-vv-name="comm2GN"
                  :data-vv-as="labels.comm2GN"
                  :error-messages="errors.collect('comm2GN')"
                ></v-autocomplete>
              </v-flex>
            </v-layout>

            <!-- Commission 3 -->
            <v-layout row wrap>
              <v-flex lg6 md6 xs12>
                <v-layout row wrap>
                  <v-flex v-if="queryMode">
                    <v-checkbox readonly v-model="treatyForm.comm3AE" :label="labels.comm3AE"></v-checkbox>
                  </v-flex>
                  <v-flex v-else>
                    <v-checkbox
                      v-model="treatyForm.comm3AE"
                      :label="labels.comm3AE"
                      :error-messages="errors.collect('comm3AE')"
                      data-vv-name="comm3AE"
                      :data-vv-as="labels.comm3AE"
                      v-validate="'required'"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.comm3Pct }}</v-subheader>
                    <div class="queryValue">{{ treatyForm.comm3Pct }}</div>
                  </v-flex>
                  <v-flex v-else>
                    <v-text-field
                      v-model="treatyForm.comm3Pct"
                      :label="labels.comm3Pct"
                      :error-messages="errors.collect('comm3Pct')"
                      data-vv-name="comm3Pct"
                      :data-vv-as="labels.comm3Pct"
                      v-validate="'required|mask_decimal:6|mask_min_value:0.000000'"
                      v-num-mask="{ negative: true, intScale: 18, decScale: 6 }"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex lg6 md6 xs12 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.comm3GN }}</v-subheader>
                <div class="queryValue" v-for="item in filterComm3GNList" :key="item.code">{{ item.value }}</div>
              </v-flex>
              <v-flex lg6 md6 xs12 v-else>
                <v-autocomplete
                  :label="labels.comm3GN"
                  :items="comm3GNList"
                  v-model="treatyForm.comm3GN"
                  item-text="value"
                  item-value="code"
                  data-vv-name="comm3GN"
                  :data-vv-as="labels.comm3GN"
                  :error-messages="errors.collect('comm3GN')"
                ></v-autocomplete>
              </v-flex>
            </v-layout>

            <!-- Cash Loss Limit -->
            <v-layout row wrap>
              <v-flex lg6 md6 xs12 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.cashLossLim }}</v-subheader>
                <div class="queryValue">{{ treatyForm.cashLossLim }}</div>
              </v-flex>
              <v-flex lg6 md6 xs12 v-else>
                <v-text-field
                  v-model="treatyForm.cashLossLim"
                  :label="labels.cashLossLim"
                  :error-messages="errors.collect('cashLossLim')"
                  data-vv-name="cashLossLim"
                  :data-vv-as="labels.cashLossLim"
                  v-num-mask="{ negative: false, intScale: 18, decScale: 2 }"
                  v-validate="'mask_decimal:2|mask_min_value:0.00'"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <!-- UW PortFolio -->
            <v-layout row wrap>
              <v-flex lg6 md6 xs12 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.uwYrPfolio }}</v-subheader>
                <div class="queryValue" v-for="item in filterUwYrPfolioList" :key="item.code">{{ item.value }}</div>
              </v-flex>
              <v-flex lg6 md6 xs12 v-else>
                <v-autocomplete
                  :label="labels.uwYrPfolio"
                  :items="uwYrPfolioList"
                  v-model="treatyForm.uwYrPfolio"
                  item-text="value"
                  item-value="code"
                  data-vv-name="uwYrPfolio"
                  :data-vv-as="labels.uwYrPfolio"
                  :error-messages="errors.collect('uwYrPfolio')"
                ></v-autocomplete>
              </v-flex>
              <!-- Level No. -->
              <v-flex lg6 md6 xs12 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.lvlNo }}</v-subheader>
                <div class="queryValue">{{ treatyForm.lvlNo }}</div>
              </v-flex>
              <v-flex lg6 md6 xs12 v-else>
                <v-text-field
                  v-model="treatyForm.lvlNo"
                  :label="labels.lvlNo"
                  :error-messages="errors.collect('lvlNo')"
                  data-vv-name="lvlNo"
                  :data-vv-as="labels.lvlNo"
                  v-validate="'mask_decimal:0'"
                ></v-text-field>
              </v-flex>
              <!-- Treaty Basis -->
              <v-flex lg6 md6 xs12 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.ttyGN }}</v-subheader>
                <div class="queryValue" v-for="item in filterTtyGNList" :key="item.code">{{ item.value }}</div>
              </v-flex>
              <v-flex lg6 md6 xs12 v-else>
                <v-autocomplete
                  :label="labels.ttyGN"
                  :items="ttyGNList"
                  v-model="treatyForm.ttyGN"
                  item-text="value"
                  item-value="code"
                  data-vv-name="ttyGN"
                  :data-vv-as="labels.ttyGN"
                  :error-messages="errors.collect('ttyGN')"
                ></v-autocomplete>
              </v-flex>
              <!-- Cash Call Expiry Date -->
              <v-flex lg6 md6 xs12 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.cashCallExpDate }}</v-subheader>
                <div class="queryValue">{{ treatyForm.cashCallExpDate }}</div>
              </v-flex>
              <v-flex lg6 md6 xs12 v-else>
                <cal-picker
                  :label="labels.cashCallExpDate"
                  v-model="treatyForm.cashCallExpDate"
                  :error-messages="errors.collect('cashCallExpDate')"
                  data-vv-name="cashCallExpDate"
                  :data-vv-as="labels.cashCallExpDate"
                  v-validate="'required'"
                ></cal-picker>
              </v-flex>
              <!-- Permitted Business Class Per Treaty -->
              <v-flex lg6 md6 xs12 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.pmtBusClsPerTty }}</v-subheader>
                <div class="queryValue">{{ treatyForm.pmtBusClsPerTty }}</div>
              </v-flex>
              <v-flex lg6 md6 xs12 v-else>
                <v-textarea
                  v-model="treatyForm.pmtBusClsPerTty"
                  :label="labels.pmtBusClsPerTty"
                  data-vv-name="pmtBusClsPerTty"
                  :data-vv-as="labels.pmtBusClsPerTty"
                  v-validate="'max:5000'"
                  auto-grow
                  rows="3"
                  row-height="25"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('pmt')"
                  :readonly="!queryMode"
                >
                </v-textarea>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout v-if="!newMode">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(modifiedDate) }}</div>
              </v-flex>
            </v-layout>
            <!-- Buttons -->
            <v-layout row wrap>
              <v-btn class="mr-2" color="error" @click="doCancel" :loading="submitting">
                <span>Cancel</span>
                <v-icon right dark>mdi-cancel</v-icon>
              </v-btn>
              <v-btn :disabled="queryMode" color="primary" @click="doSave" :loading="submitting">
                <span>Save</span>
                <v-icon right dark>mdi-content-save</v-icon>
              </v-btn>
            </v-layout>
          </v-container>
          <v-dialog v-model="filterList" width="900px" persistent>
            <pmt-filter v-if="pmtFilter" :pmt="treatyForm.pmtBusClsPerTty" @close="doClose" @doAssign="doAssign($event)"></pmt-filter>
          </v-dialog>
        </v-card-text>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import * as TableConst from '@/mixins/table'
import { formatDisplayDate, formatDisplayDate2 } from '@/utils/date'
import { expandURI } from '@/utils/ajax'
import PmtFilter from './PmtFilter.vue'
import { formatPrice } from '@/utils/index'
import { removeFormatNumber } from '@/utils/number'
import clone from 'clone'
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'

export default {
  data() {
    return {
      labels: {
        cashCallExpDate: 'Cash Call Expiry Date ',
        cashLossLim: 'Cash Loss Limit',
        comm1AE: 'Commission 1 A/E',
        comm1Pct: 'Commission 1 % ',
        defComm1: 'Default for Commission 1',
        comm1AEPct: 'Commission 1 A/E / %',
        comm2AE: 'Commission 2 A/E',
        comm2GN: 'Commission 2 Gross / Net ',
        comm2AEPct: 'Commission 2 A/E / %',
        comm2Pct: 'Commission 2 % ',
        comm3AE: 'Commission 3 A/E',
        comm3GN: 'Commission 3 Gross / Net',
        comm3AEPct: 'Commission 3 A/E / %',
        comm3Pct: 'Commission 3 % ',
        commonTtyDesc: '',
        commonTtyNo: '',
        effDate: 'Effective Date',
        expDate: 'Expiry Date',
        lvlNo: 'Level No. ',
        ttyDesc: 'Treaty Name',
        ttyGN: 'Treaty Basis (Gross / Net)',
        ttyNo: 'Treaty Reference ',
        ttyType: 'RI Type',
        ttyYr: 'Treaty Year',
        uwYrPfolio: 'Underwriting Year or Portfolio',
        pmtBusClsPerTty: 'Permitted Business Class Per Treaty',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      treatyForm: {
        cashCallExpDate: new Date(), // def expdata
        cashLossLim: 0,
        comm1AE: false,
        comm1Pct: 0,
        defComm1: false,
        comm2AE: false,
        comm2GN: 'G',
        comm2Pct: 0,
        comm3AE: false,
        comm3GN: 'G',
        comm3Pct: 0,
        commonTtyDesc: '-',
        commonTtyNo: '-',
        effDate: new Date(),
        expDate: new Date(),
        lvlNo: 1, // if ttyType == 'D', change to 0, set method later
        ttyDesc: '',
        ttyGN: 'G',
        ttyNo: '',
        ttyType: '',
        ttyYr: 0,
        uwYrPfolio: 'U',
        pmtBusClsPerTty: ''
      },
      newMode: false,
      queryMode: false,
      reviewMode: false,
      ttyYrLoading: false,
      submitting: false,
      pmtFilter: false,
      filterList: false,
      createdBy: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
      createdDate: new Date(),
      modifiedBy: '',
      modifiedDate: undefined,
      menu: {},
      sideFunction: [
        { text: 'Treaty Detail', icon: 'mdi-tune', iconColor: 'primary', params: { name: 'treatyDetail', params: { ttyNo: this.treatyForm } } }
        // { text: 'Treaty Period', icon: 'mdi-tune', iconColor: 'primary', params: { name: 'treatyPeriod', params: { ttyNo: this.treatyForm } } }
      ],
      ttyTypeList: [
        { code: 'C', value: 'C - Coinsurance' },
        { code: 'D', value: 'D - Statutory' }, // uncommented 29-Jan-2021
        { code: 'F', value: 'F - Facultative' },
        { code: 'T', value: 'T - Treaty' },
        { code: 'W', value: 'W - Quota Share' },
        { code: 'X', value: 'X - XOL' }
      ],
      comm2GNList: [
        { code: 'G', value: 'Gross', TF: true },
        { code: 'N', value: 'Net', TF: false }
      ],
      comm3GNList: [
        { code: 'G', value: 'Gross', TF: true },
        { code: 'N', value: 'Net', TF: false }
      ],
      uwYrPfolioList: [
        { code: 'U', value: 'Underwriting Year' },
        { code: 'P', value: 'Portfolio' }
      ],
      ttyGNList: [
        { code: 'G', value: 'Gross', TF: true },
        { code: 'N', value: 'Net', TF: false }
      ]
    }
  },
  methods: {
    async doFetch() {
      const apiURI = this.treatyMenu.treaty
      if (apiURI) {
        this.loading = true
        try {
          const expand = { ttyNoParam: this.ttyNoParam }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.sideFunction.push({
              text: 'Treaty Period',
              icon: 'mdi-tune',
              iconColor: 'primary',
              params: { name: 'treatyPeriod', params: { ttyForm: this.treatyForm } }
            })
            // display date in format if query mode
            if (this.queryMode) {
              this.treatyForm.cashCallExpDate = formatDisplayDate(data.ttyNoParam.cashCallExpDate)
              this.treatyForm.effDate = formatDisplayDate(data.ttyNoParam.effDate)
              this.treatyForm.expDate = formatDisplayDate(data.ttyNoParam.expDate)
            } else {
              this.treatyForm.cashCallExpDate = data.ttyNoParam.cashCallExpDate
              this.treatyForm.effDate = data.ttyNoParam.effDate
              this.treatyForm.expDate = data.ttyNoParam.expDate
            }
            this.treatyForm.cashLossLim = formatPrice(data.ttyNoParam.cashLossLim)
            this.treatyForm.comm1AE = data.ttyNoParam.comm1AE
            this.treatyForm.defComm1 = data.ttyNoParam.defComm1
            this.treatyForm.comm1Pct = data.ttyNoParam.comm1Pct
            this.treatyForm.comm2AE = data.ttyNoParam.comm2AE
            if (data.ttyNoParam.comm2GN === undefined) {
              this.treatyForm.comm2GN = ''
            } else {
              this.treatyForm.comm2GN = data.ttyNoParam.comm2GN
            }
            this.treatyForm.comm2Pct = data.ttyNoParam.comm2Pct
            this.treatyForm.comm3AE = data.ttyNoParam.comm3AE
            if (data.ttyNoParam.comm3GN === undefined) {
              this.treatyForm.comm3GN = ''
            } else {
              this.treatyForm.comm3GN = data.ttyNoParam.comm3GN
            }
            this.treatyForm.comm3Pct = data.ttyNoParam.comm3Pct
            if (data.ttyNoParam.commonTtyDesc === undefined) {
              this.treatyForm.commonTtyDesc = ''
            } else {
              this.treatyForm.commonTtyDesc = data.ttyNoParam.commonTtyDesc
            }

            if (data.ttyNoParam.commonTtyNo === undefined) {
              this.treatyForm.commonTtyNo = ''
            } else {
              this.treatyForm.commonTtyNo = data.ttyNoParam.commonTtyNo
            }
            this.treatyForm.lvlNo = data.ttyNoParam.lvlNo
            this.treatyForm.ttyDesc = data.ttyNoParam.ttyDesc
            if (data.ttyNoParam.ttyGN === undefined) {
              this.treatyForm.ttyGN = ''
            } else {
              this.treatyForm.ttyGN = data.ttyNoParam.ttyGN
            }
            this.treatyForm.ttyNo = data.ttyNoParam.ttyNo
            this.treatyForm.ttyType = data.ttyNoParam.ttyType
            this.treatyForm.ttyYr = data.ttyNoParam.ttyYr
            if (data.ttyNoParam.uwYrPfolio === undefined) {
              this.treatyForm.uwYrPfolio = ''
            } else {
              this.treatyForm.uwYrPfolio = data.ttyNoParam.uwYrPfolio
            }
            if (data.pmtBusClsPerTty.length > 0) {
              // If the array get from backend, join it with a comma
              const arrPmt = []
              for (var i = 0; i < data.pmtBusClsPerTty.length; i++) {
                arrPmt.push(data.pmtBusClsPerTty[i].busCls)
              }
              this.treatyForm.pmtBusClsPerTty = arrPmt.join(',')
            }
            this.createdBy = data.createdBy
            this.createdDate = data.createdDate
            this.modifiedBy = data.modifiedBy
            this.modifiedDate = data.modifiedDate
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.loading = false
      }
    },
    async doTranDate() {
      const apiURI = this.treatyMenu.checkTtyYt
      let effDate = formatDisplayDate2(this.treatyForm.effDate)
      if (apiURI && effDate) {
        this.loading = true
        this.ttyYrLoading = true
        try {
          // Use formatDisplayDate2 as CORS Policy does not accept '/' to be passed in get method
          const expand = { tranDate: formatDisplayDate2(this.treatyForm.effDate) }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            if (data.tranDate) {
              this.treatyForm.ttyYr = data.tranDate.acctPerYr
            } else {
              this.treatyForm.ttyYr = 0
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.loading = false
        this.ttyYrLoading = false
      }
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else if (this.reviewMode) {
            this.doUpdate()
            // } else {
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doCancel() {
      this.$router.push({ name: 'treatyParamsList' })
    },
    async doCreate() {
      const apiURI = this.treatyMenu.createTreaty
      const form = this.treatyForm
      if (apiURI) {
        this.submitting = true
        try {
          // Starts here
          let messageForm = clone(form)
          if (messageForm.cashLossLim) {
            messageForm.cashLossLim = removeFormatNumber(messageForm.cashLossLim)
          }
          const result = await this.$http.post(apiURI, messageForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.message(data)
            this.fieldMessage(data)
            this.doCancel()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.treatyMenu.updateTreaty
      const form = this.treatyForm
      if (apiURI) {
        this.submitting = true
        try {
          // Starts
          let messageForm = clone(form)
          if (messageForm.cashLossLim) {
            messageForm.cashLossLim = removeFormatNumber(messageForm.cashLossLim)
          }
          const result = await this.$http.put(apiURI, messageForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doCancel()
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    getHelpList(fieldName) {
      if (fieldName === 'pmt') {
        this.pmtFilter = true
      }
      this.filterList = true
    },
    doClose() {
      this.filterList = false
    },
    doAssign(Obj) {
      this.treatyForm.pmtBusClsPerTty = []
      this.treatyForm.pmtBusClsPerTty = Obj.selectedItems.toString()
      this.pmtFilter = false
    },
    sideMenuClick(data) {
      this.$router.push({ name: data.name, params: data.params })
    },
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    formatPrice(data) {
      return formatPrice(data)
    }
  },
  computed: {
    treatyMenu() {
      return this.$store.state.treatyParam.menu
    },
    ttyNoParam() {
      return this.$route.params.ttyNoParam
    },
    modeTreaty() {
      return this.$route.params.modeTreaty
    },
    filterTtyTypeToList() {
      return this.ttyTypeList.filter((list) => {
        return list.code === this.treatyForm.ttyType
      })
    },
    filterComm2GNList() {
      return this.comm2GNList.filter((list) => {
        return list.code === this.treatyForm.comm2GN
      })
    },
    filterComm3GNList() {
      return this.comm3GNList.filter((list) => {
        return list.code === this.treatyForm.comm3GN
      })
    },
    filterUwYrPfolioList() {
      return this.uwYrPfolioList.filter((list) => {
        return list.code === this.treatyForm.uwYrPfolio
      })
    },
    filterTtyGNList() {
      return this.ttyGNList.filter((list) => {
        return list.code === this.treatyForm.ttyGN
      })
    },
    ttyNoWatch() {
      return this.treatyForm.ttyNo
    },
    ttyTypeWatch() {
      return this.treatyForm.ttyType
    },
    lvlNoWatch() {
      return this.treatyForm.lvlNo
    },
    effDateValidation() {
      return 'required'
    },
    expDateValidation() {
      if (this.treatyForm.expDate !== undefined && this.treatyForm.expDate !== '') {
        return 'required|start_enddate:' + this.treatyForm.effDate
      } else {
        return 'required'
      }
    },
    expDateWatch() {
      return this.treatyForm.expDate
    }
  },
  watch: {
    ttyTypeWatch(value) {
      if (this.newMode) {
        if (value === 'D') {
          this.treatyForm.lvlNo = 0
        } else {
          this.treatyForm.lvlNo = 1
        }
      }
    },
    expDateWatch(value) {
      if (this.newMode) {
        this.treatyForm.cashCallExpDate = value
      }
    }
  },
  mounted() {},
  created() {
    if (this.ttyNoParam === 'New') {
      this.newMode = true
    } else if (!this.ttyNoParam) {
      this.doCancel()
    } else {
      if (this.modeTreaty === 'Query') {
        this.queryMode = true
      } else if (this.modeTreaty === 'Review') {
        this.reviewMode = true
      }
      this.doFetch()
    }
  },
  filters: {
    formatDate(value) {
      return formatDisplayDate2(value)
    }
  },
  mixins: [TableConst.default, MessageMixin],
  components: {
    PmtFilter,
    SideFunctionMenu
  }
}
</script>
